import authInstance from "../Interceptor/interceptor";

export const addTransferPatientEffect = (transferPatientData) => {
    return authInstance.post("/roomshifting/insert", transferPatientData);
};

export const deleteTransferPatientEffect = (id) => {
    return authInstance.delete(`/transferPatient/delete/${id}`);
};

export const editTransferPatientEffect = (id, formData) => {
    return authInstance.put(`/transferPatients/updateTransferPatient/${id}`, formData);
};
export const ViewTransferPatientEffect = (transferPatientId,pageNo) => {
    return authInstance.get(`/roomshifting/getroomshsiftbystaff?staff_id=${transferPatientId}&pageNo=1&pagesize=100&pagination_required=true`);
};
export const listTransferPatientEffect = (pageNo) => {
    return authInstance.get(`/roomshifting/roomshiftgetall?pageNo=${pageNo}&pagesize=10&pagination_required=true&search_by=kumar`);
};

export const historyTransferPatientEffect = (pageNo) => {
    return authInstance.get(`/attenderbooking/getbysecirity?pageNo=${pageNo}&pagesize=10&pagination_required=true`);
};